import { Routes } from '@angular/router';
import { SettingsViewComponent } from './views/settings-view/settings-view.component';
import { MachinesViewComponent } from './views/machines-view/machines-view.component';
import { MachineDetailsComponent } from './views/machines-view/components/machine-details/machine-details.component';
import { TeamsViewComponent } from './views/teams-view/teams-view.component';
import { MsalGuard } from '@azure/msal-angular';
import { DefinitionViewComponent } from './views/definition-view/definition-view.component';
import { TeamDetailsComponent } from './views/teams-view/components/team-details/team-details.component';
import { ContractorViewComponent } from './views/contractor-view/contractors-view.component';
import { ContractorDetailsComponent } from './views/contractor-view/contractor-details/contractor-details.component';
import { PendingChangesGuard } from './core/guards/pending-changes.guard';
import { MachinePerformancesViewComponent } from './views/machine-performances-view/machine-performances-view.component';
import { UsersViewComponent } from './views/users-view/users-view.component';

export const routes: Routes = [
  {
    path: '',
    component: MachinesViewComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'machines',
    component: MachinesViewComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'machine/:machineId',
    component: MachineDetailsComponent,
    canActivate: [MsalGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'newmachine/:machineId',
    component: MachineDetailsComponent,
    canActivate: [MsalGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'teams',
    component: TeamsViewComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'team/:teamId',
    component: TeamDetailsComponent,
    canActivate: [MsalGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'definitions',
    component: DefinitionViewComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'contractors',
    component: ContractorViewComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'contractor/:contractorId',
    component: ContractorDetailsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'machine-performances',
    component: MachinePerformancesViewComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'settings',
    component: SettingsViewComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'users',
    component: UsersViewComponent,
    canActivate: [MsalGuard]
  }
];
